"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-3903acbe"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "form-padding" };
const _hoisted_2 = { class: "oplus-form-checkbox" };
const _hoisted_3 = ["value"];
const vue_3 = require("vue");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roleRequest_1 = require("../../requests/roleRequest");
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionEmployeeList',
    props: {
        userId: {
            type: Number,
            required: true
        },
        branchId: {
            type: Number,
            required: true,
        }
    },
    setup(__props) {
        const { addRoleSection } = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewInjectionKey, { addRoleSection: () => { }, deleteRoleSection: () => { } });
        const userStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleSectionUserStore);
        const selectedRole = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewSelectedRole, undefined);
        const selectedIds = (0, vue_3.ref)(selectedRole?.value?.getJoinedEmployees() || []);
        const props = __props;
        const users = (0, vue_3.computed)(() => {
            return userStore?.query({}) || [];
        });
        const userIds = (0, vue_3.computed)(() => {
            return users.value.map(user => Number(user.getId()));
        });
        async function handleUpdateRoleSectionEmployees() {
            const payload = {
                roleId: Number(selectedRole?.value?.getId() || 0),
                employeeIds: selectedIds.value,
            };
            try {
                const response = await (0, roleRequest_1.updateRoleEmployees)(props.branchId, props.userId, payload);
                if (!response.success) {
                    throw new Error();
                }
                // update role section
                addRoleSection(response.role);
            }
            catch (err) {
                (0, roles_1.openAlertModal)("エラーが発生しました。恐れ入りますが、ページをリロードして再度お試しください。");
            }
        }
        function selectAll() {
            selectedIds.value = userIds.value;
            handleUpdateRoleSectionEmployees();
        }
        function deselectAll() {
            selectedIds.value = [];
            handleUpdateRoleSectionEmployees();
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.createElementVNode)("div", { class: "d-flex flex-gap form-padding" }, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "oplus-btn staff-select-button",
                            onClick: selectAll
                        }, "全員選択"),
                        (0, vue_2.createElementVNode)("button", {
                            class: "oplus-btn staff-select-button",
                            onClick: deselectAll
                        }, "全員解除")
                    ]),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(users.value, (user) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                            (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                (0, vue_2.createElementVNode)("label", _hoisted_2, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        type: "checkbox",
                                        value: Number(user.getId()),
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedIds).value = $event)),
                                        onChange: handleUpdateRoleSectionEmployees
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
                                        [vue_2.vModelCheckbox, selectedIds.value]
                                    ]),
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(user.getName()), 1 /* TEXT */)
                                ])
                            ])
                        ]));
                    }), 256 /* UNKEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
